import React, { Component } from 'react';
import _ from 'lodash';

import SwipeableViews from 'react-swipeable-views';
import SwipeCloseModal from './../SwipeCloseModal/SwipeCloseModal';

import './SwipeableModal.css';

export class SwipeableModal extends Component {
  constructor(props) {
    super(props);

    let selectedPreviewIndex = -1;

    if (props) {
      const { previews, selectedPreview } = props;
      selectedPreviewIndex = _.findIndex(previews, (preview) => {
        return preview.ad_id === selectedPreview.ad_id;
      });
    }

    this.state = {
      currentRenderingPreviewIndex: selectedPreviewIndex,
      renderedPreviewIndexes: [],
      isOnSwitching: false
    };
  }

  onModalClose = () => {
    const { resetMobileStateOnModalClose } = this.props;
    if (resetMobileStateOnModalClose) {
      setTimeout(() => {
        resetMobileStateOnModalClose();
      }, 300);
    }
  };

  onChangeIndex = (index) => {
    const { renderedPreviewIndexes, currentRenderingPreviewIndex } = this.state;
    const newIndexes = [...renderedPreviewIndexes];
    if (!_.includes(newIndexes, currentRenderingPreviewIndex)) {
      newIndexes.push(currentRenderingPreviewIndex);
    }

    this.setState(
      {
        ...this.state,
        currentRenderingPreviewIndex: index,
        renderedPreviewIndexes: newIndexes,
        isOnSwitching: false
      },
      async () => {
        await this.props.loadSwipeableModalPreview(index);
      }
    );
  };

  onSwitching = () => {
    this.setState((prevState) => {
      return {
        ...prevState,
        isOnSwitching: true
      };
    });
  };

  render() {
    const {
      currentRenderingPreviewIndex = -1,
      closing,
      isOnSwitching,
      renderedPreviewIndexes
    } = this.state;
    const { previews, getAdName, renderAdDetail } = this.props;

    if (currentRenderingPreviewIndex === -1) return null;
    const styles = {
      slide: {
        height: window.innerHeight,
        overflow: 'hidden' // to prevent unnecessary scroll
      }
    };

    let initialPreviewIndex = 0;
    initialPreviewIndex = currentRenderingPreviewIndex;

    return (
      <div
        className="swipeable-modal-container"
        style={
          closing
            ? {
                backgroundColor: 'rgba(255, 255, 255, 0)',
                transform: `translate(0px, ${window.innerHeight}px)`,
                transition: `background-color 0.2s, transform 0.2s 0.2s`
              }
            : {}
        }
      >
        <div className="swipeable-modal-inner-container">
          <SwipeableViews
            slideStyle={{
              paddingLeft: '10px',
              paddingRight: '10px',
              overflow: 'hidden'
            }} // the overflow:hidden prevents the slide moving.
            onChangeIndex={this.onChangeIndex}
            onSwitching={this.onSwitching}
            resistance
            hysteresis={0.5}
            index={initialPreviewIndex}
          >
            {previews &&
              previews.map((preview, previewIndex) => {
                let content = null;
                const { ad_name: adName, ad_id: adId } = preview;
                const adTitle = getAdName(adName);
                const shouldPreviewRender =
                  currentRenderingPreviewIndex === previewIndex;

                if (shouldPreviewRender) {
                  content = renderAdDetail(preview);
                } else {
                  content = adTitle;
                }

                return (
                  <div key={adId} style={{ ...styles.slide }}>
                    <SwipeCloseModal
                      onModalClose={this.onModalClose}
                      adTitle={adTitle}
                      content={content}
                      previewIndex={previewIndex}
                      isOnSwitching={isOnSwitching}
                      renderedPreviewIndexes={renderedPreviewIndexes}
                    />
                  </div>
                );
              }, this)}
          </SwipeableViews>
        </div>
      </div>
    );
  }
}

export default SwipeableModal;



// WEBPACK FOOTER //
// ./src/components/common/SwipeableModal/SwipeableModal.jsx